import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Products } from '@grandvisionhq/api-client';
import { useApiConfig } from '@grandvisionhq/state';

function useGetProductsBySku(skus, limit) {
    const { productsUrl  } = useApiConfig();
    const [state, setState] = React.useState({
        products: [],
        isLoading: true,
        error: null
    });
    React.useEffect(()=>{
        let isCancelled = false;
        function loadProducts() {
            return _loadProducts.apply(this, arguments);
        }
        function _loadProducts() {
            _loadProducts = swcHelpers.asyncToGenerator(function*() {
                try {
                    const products = yield fetchProducts(productsUrl, skus, limit);
                    if (products && !isCancelled) {
                        setState(swcHelpers.objectSpread({}, state, {
                            products,
                            isLoading: false
                        }));
                    }
                } catch (error) {
                    console.error(error);
                    if (!isCancelled) {
                        setState(swcHelpers.objectSpread({}, state, {
                            error,
                            isLoading: false
                        }));
                    }
                }
            });
            return _loadProducts.apply(this, arguments);
        }
        (skus === null || skus === void 0 ? void 0 : skus.length) && loadProducts();
        return ()=>{
            isCancelled = true;
        };
    }, [
        productsUrl,
        skus
    ]);
    return state;
}
function fetchProducts(apiUrl) {
    return _fetchProducts.apply(this, arguments);
}
function _fetchProducts() {
    _fetchProducts = swcHelpers.asyncToGenerator(function*(apiUrl, skus = [], limit) {
        if (!skus.length) {
            return [];
        }
        const skusFilter = skus.filter((s)=>!!s.length
        ).map((sku)=>`"${sku}"`
        ).join(',');
        const filters = [
            `variants.sku:${skusFilter}`
        ];
        const expand = [
            'productType',
            'masterVariant.prices[*].discounted.discount',
            'variants[*].prices[*].discounted.discount', 
        ];
        const { results  } = yield Products.query(apiUrl, {
            filters,
            expand
        });
        const sortedProducts = sortProducts(skus, results);
        return limit ? sortedProducts.slice(0, limit) : sortedProducts;
    });
    return _fetchProducts.apply(this, arguments);
}
// The Product service currently doesn't have a way to return the products in the same order
// as the SKUs array is provided, so we have to manually sort the products based on the SKU array.
function sortProducts(skus, products = []) {
    return [
        ...products
    ].sort((productA, productB)=>{
        const indexA = skus.findIndex((sku)=>[
                productA.masterVariant,
                ...productA.variants
            ].find((v)=>v.sku === sku
            )
        );
        const indexB = skus.findIndex((sku)=>[
                productB.masterVariant,
                ...productB.variants
            ].find((v)=>v.sku === sku
            )
        );
        return indexA - indexB;
    });
}

export { fetchProducts, sortProducts, useGetProductsBySku };
//# sourceMappingURL=use-get-products-by-sku.js.map
